<script setup>
  import { computed } from "vue";

  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "알림",
    },
    confirmButtonText: {
      type: String,
      default: "확인",
    },
    size: {
      type: String,
      default: "xs",
    },
    keepOpenModal: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: true,
    },
  });

  const emits = defineEmits(["update:show", "submit"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const closeModal = () => {
    emits("update:show", false);
  };

  const submitModal = () => {
    closeModal();
    emits("submit");
  };
</script>

<template>
  <ui-modal :closable="closable" :maskClosable="keepOpenModal" v-model:show="localShow" :size="size" :title="title">
    <template #body>
      <slot />
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <ui-button @click="submitModal">
          {{ confirmButtonText }}
        </ui-button>
      </div>
    </template>
  </ui-modal>
</template>
